import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import { FormGroupControl, FormGroupSelect, FormGroupTypeahead } from '@components/Base';
import { selectIsHospital } from '@components/Auth';
import bankNames from '@models/bankNames.json';
import { PaymentMethods } from '@models/PaymentInfo';
import { FormValues } from './schema';

const GROUP_PROPS = { className: 'mb-3' };

const PaymentInfoCardBody = () => {
  const { t } = useTranslation();
  const {
    values: { paymentInfo },
  } = useFormikContext<Pick<FormValues, 'paymentInfo'>>();
  const isHospital = useSelector(selectIsHospital);
  const isPaymentMethodByBankTransfer = paymentInfo?.paymentMethod === 'bank_transfer' || isHospital;

  return (
    <Card.Body>
      <Card.Title>{t('paymentInfo.title')}</Card.Title>
      <Row>
        <Col>
          <FormGroupSelect
            required
            name="paymentInfo[paymentMethod]"
            label={t('paymentInfo.paymentMethod')}
            groupProps={GROUP_PROPS}
            disabled={isHospital}
          >
            <option value={PaymentMethods.BankTransfer}>{t('paymentInfo.bankTransfer')}</option>
          </FormGroupSelect>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            required
            name="paymentInfo[beneficiaryName]"
            label={t('paymentInfo.beneficiaryName')}
            groupProps={GROUP_PROPS}
            disabled={isHospital}
          />
        </Col>
      </Row>
      {isPaymentMethodByBankTransfer && (
        <Row>
          <Col>
            <FormGroupTypeahead
              required
              name="paymentInfo[bankName]"
              label={t('paymentInfo.bankName')}
              options={bankNames}
              defaultSelectedOptions={[!isEmpty(paymentInfo?.bankName) ? paymentInfo.bankName : '']}
              groupProps={GROUP_PROPS}
              disabled={isHospital}
            />
          </Col>
          <Col>
            <FormGroupControl
              required
              name="paymentInfo[bankAccount]"
              label={t('paymentInfo.bankAccount')}
              groupProps={GROUP_PROPS}
              disabled={isHospital}
            />
          </Col>
        </Row>
      )}
    </Card.Body>
  );
};

export { PaymentInfoCardBody };
